import angular from 'angular';
import _ from 'lodash-es';
import { DEFINED_BY } from '~/scripts/constants/common-kids';
import APIV5 from '~/models/api';
import Form from '~/scripts/services/model/form';
import Query from '~/scripts/services/model/query';
import { createKtableWidgetActionType } from '~/pages/dashboard/models/widget';
import QueryWhereChild from '~/scripts/services/model/query-where-child';
import QueryWhereNode from '~/scripts/services/model/query-where-node';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryWhere from '~/scripts/services/model/query-where';
import QueryRule from '~/scripts/services/model/query-rule';

/* globals Knitiv, KtableFormConfig */

/**
 * @typedef {KtableFormConfig.Scope} Scope The current scope
 */

export const fixComponentOptionsActionInsert = (/** @type {any} */ component) => {
	if (
		component.options.actions.insert !== undefined
		&& component.options.actions.insertCreate === undefined
		&& component.options.actions.insertExisting === undefined
	) {
		component.options.actions.insertCreate = component.options.actions.insert;
		component.options.actions.insertExisting = component.options.actions.insert;
		delete component.options.actions.insert;
	}
};

export const setWhere = (
	/** @type {Query} */ query,
	/** @type {any} */ filter,
	/** @type {Node | any} */ node,
) => {
	if (filter && node && !query.findRule((/** @type {QueryRule} */ rule) => rule.value[0].kid === '_KID_')) {
		if (query.version && query.version >= '3.0.0') {
			query.where = new QueryWhereChild();
			query.where.node = new QueryWhereNode({
				kid:  node.kid,
				name: node.getName(),
			});
			query.where.rules?.items.push(new QueryWhereRule({
				field:    'kid',
				operator: 'equal_kid',
				value:    [{ kid: '_KID_' }],
			}));
		}
		else {
			// eslint-disable-next-line unicorn/consistent-destructuring
			query.where = new QueryWhere({
				rules: [
					new QueryRule({
						field:      filter.kid,
						label:      filter.name,
						operator:   'equal_kid',
						path:       [
							{
								kid:  node.kid,
								name: node.getName(),
								flow: undefined,
							},
							{
								kid:        filter.kid,
								name:       filter.name,
								flow:       'down',
								linker_kid: filter.linker_kid || '0',
							},
						],
						type:       'K_NODE;STRING',
						value:      [{ kid: '_KID_' }],
						linker_kid: filter.linker_kid || '0',
					}),
				],
			});

			if (filter.linker_kid !== '0' && query.where.rules[0] instanceof QueryRule) {
				query.where.rules[0].path[1].linker_info = filter.linker_info;
				query.where.rules[0].linker_info = filter.linker_info;
			}
		}
	}
};

/**
 *
 * @param {import('angular').IScope & Scope} $scope
 * @param {any} NodeService
 * @param {import('angular').IQService} $q
 * @param {import('angular').ICompileService} $compile
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {import('angular').ILocationService} $location
 * @param {Knitiv.RootScope} $rootScope
 * @param {import('angular').ITimeoutService} $timeout
 */
export default /* @ngInject */ (
	$scope,
	NodeService,
	$q,
	$compile,
	$injector,
	$location,
	$rootScope,
	$timeout,
) => {
	/** @type {any} */
	// @ts-ignore
	const component = $scope.component ?? $scope.$parent.component;

	component.definedby = [];

	if (!(component.query instanceof Query)) {
		component.query = new Query(component.query);
	}

	$scope.ktableOptions = _.cloneDeep($scope.component.options);

	/** @type {import('~/scripts/services/model/node').default} */
	let node;
	const parent = $scope.$parent;
	// @ts-ignore
	const form = parent.form || undefined;

	fixComponentOptionsActionInsert(component);

	if (!$scope.builder && form) {
		// Recherche du link
		$scope.ktableOptions.parent = {
			create: form.create,
			kid:    form.kid,
			isa:    form.isa,
			name:   form instanceof Form ? form.getName() : form.name,
			target: component.options.target,
		};
	}

	const loadNode = (/** @type {any} */ newNode) => {
		const result = NodeService
			.load(newNode)
			.then((/** @type {import('~/scripts/services/model/node').default} */ n) => {
				node = n;
				component.query = new Query({
					select: [],
					from:   [
						{
							node:              node.kid,
							name:              node.getName(),
							type:              node.type_kid,
							inherits_extended: -1,
						},
					],
					where:  undefined,
					date:   '_NOW_',
				});

				if ('component' in $scope.$parent.$parent) {
					// @ts-ignore
					$scope.$parent.$parent.krepre_mode = node.krepre.mode;
					// @ts-ignore
					$scope.$parent.$parent.definedby = node.link.filter(
						link => link.flow === 'from' && link.relation_kid === DEFINED_BY,
					).map(v => {
						/** @type {any} */
						const returnValue = {
							kid:         v.objnum2_kid,
							name:        v.objname,
							linker_kid:  v.linker_kid,
							linker_info: undefined,
							type_kid:    v.type_kid,
							disabled:    false,
						};

						if (v.linker_kid !== '0') {
							returnValue.linker_info = v.linker_info;
						}

						return returnValue;
					});

					if (!$scope.builder) {
						// @ts-ignore
						$scope.$parent.$parent.query = component.query;
					}

					// @ts-ignore
					for (const link of $scope.$parent.$parent.definedby) {
						if (form.isa && link.objnum2_kid === form.isa.objid) {
							// setFilter = true;
							component.filter = link;
							if (component.options.target) {
								$scope.ktableOptions.parent.target = link.linker_kid;
							}
						}
					}

					setWhere(
						component.query,
						component.filter,
						node,
					);
				}
				return true;
			});

		// Don't fetch all the possible representations in real mode
		if (!('submission' in $scope.$parent.$parent)) {
			// eslint-disable-next-line promise/catch-or-return
			result
				.then(() => {
					// @ts-ignore
					const kids = $scope.$parent.$parent.definedby.map(x => x.kid);

					return $q.when(
						Promise.all(kids.map(
							(/** @type {import('@knitiv/api-client-javascript').KNode} */ kid) => APIV5.instance.objectInfo(
								{ kid },
								{ id: 'ktable.load-node.kids-map' },
							)),
						),
					);
				})
				.then((/** @type {Array<import('@knitiv/api-client-javascript').ObjectInfoOutput>} */ repreListResult) => {
					// @ts-ignore
					$scope.$parent.$parent.valuesRepresentations = {};
					// @ts-ignore
					$scope.$parent.$parent.classRepresentations = {};

					for (const nodeClass of repreListResult) {
						const { objid } = nodeClass;

						// @ts-ignore
						// eslint-disable-next-line unicorn/consistent-destructuring
						$scope.$parent.$parent.valuesRepresentations[objid] = Object.values(nodeClass.isa_lang.list);
						// @ts-ignore
						// eslint-disable-next-line unicorn/consistent-destructuring
						$scope.$parent.$parent.classRepresentations[objid] = Object.values(nodeClass.repre.list);
					}

					return true;
				});
		}
		return result.catch((/** @type {any} */ error) => {
			console.error(error);
		});
	};

	if ('definedby' in $scope.$parent.$parent) {
		$scope.$watch('node', (newNode, oldNode) => {
			let newKid = newNode;
			let oldKid = oldNode;
			if (Array.isArray(newNode)) {
				newKid = newNode.length === 1 && 'kid' in newNode[0] ? newNode[0].kid : undefined;
			}

			if (Array.isArray(oldNode)) {
				oldKid = oldNode.length === 1 && 'kid' in oldNode[0] ? oldNode[0].kid : undefined;
			}

			if (newKid !== oldKid) {
				if (newKid) {
					loadNode(newKid);
				}
				else {
					component.filter = undefined;
					$scope.cols.length = 0;
				}
			}
		}, true);

		$scope.$watch('component.filter', (newWhere, oldWhere) => {
			if (newWhere && !angular.equals(newWhere, oldWhere)) {
				setWhere(
					component.query,
					component.filter,
					node,
				);
			}
		});
	}

	/* Extra actions */
	$scope.$eval(async () => {
		const componentActions = component.actions;

		/** @type {any[]} */
		let extraActions = [];

		/** @type {any[]} */
		let extraFetchedActions = [];

		if (componentActions.length > 0) {
			/** @type {import('@knitiv/api-client-javascript').QueryBuilder<'action' | 'type' | 'request'>} */
			const actionsQuery = APIV5.instance.createQueryBuilder();

			actionsQuery
				.select(selectBuilder => selectBuilder
					.addColumn(columnBuilder => columnBuilder
						.as('action')
						.withTarget('K_NODE;WIDGETACTION'),
					)
					.addColumn(columnBuilder => columnBuilder
						.as('type')
						.withFormat('KID')
						.withTarget('K_NODE;WDGTACTTYP')
						.withPath(pathBuilder => pathBuilder
							.flowDown('K_NODE;WDGTACTTYP'),
						),
					)
					.addColumn(columnBuilder => columnBuilder
						.as('request')
						.withFormat('KID')
						.withTarget('K_NODE;KSYSQUERY')
						.withPath(pathBuilder => pathBuilder
							.flowDown('K_NODE;WIDGET')
							.flowDown('K_NODE;KSYSQUERY'),
						),
					),
				)
				.from(fromBuilder => fromBuilder
					.addElement('K_NODE;WIDGETACTION'),
				)
				.where(whereBuilder => {
					for (const act of componentActions) {
						whereBuilder
							.addRule(ruleBuilder => ruleBuilder
								.equalKid('K_NODE;WIDGETACTION', act.kid),
							);
					}

					return whereBuilder;
				});

			try {
				const queryFeth = await actionsQuery.fetchAll(
					undefined,
					undefined,
					{ id: 'ktable-config.fetch' },
				);
				extraActions = queryFeth.resolved().rows;
			}
			catch (error) {
				console.error(error);
			}
		}

		if (extraActions.length > 0) {
			const promises = [];
			for (const [, action] of extraActions.entries()) {
				// eslint-disable-next-line no-loop-func
				promises.push(async () => {
					const currentAction = action.action[0];
					const type = action.type[0];
					// const request = action.request[0];

					// if (type.kid === 'K_NODE;WDGTACTTYP_SUBQUERY') {
					// 	subqueries.push({
					// 		name: currentAction.name,
					// 		kid: request.kid,
					// 	});
					// }

					// eslint-disable-next-line no-use-before-define
					return createKtableWidgetActionType(
						type.kid,
						// @ts-ignore
						null, // TODO:
						currentAction,
						{
							$compile,
							$injector,
							$location,
							$rootScope,
							$timeout,
						},
					);
				});
			}

			extraFetchedActions = await Promise.all(promises.map(x => x()));
		}

		$scope.ktableOptions.actions = {
			...$scope.ktableOptions.actions,
			extra: extraFetchedActions,
			// extra: [], // ensure it's empty
		};
	});

	// if (scope.node && 'definedby' in scope.$parent.$parent) {
	// 	let n = scope.node;
	// 	if (Array.isArray(n) && n.length > 0) {
	// 		n = n[0].kid;
	// 	}
	// 	if (typeof n === 'string' && n) {
	// 		loadNode(n);
	// 	}
	// }
};
